/* eslint-disable complexity */
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { connect } from "dvajs";
import { Modal, Button, Input, message, Menu, Dropdown, Popover } from "antd";
import { debounce } from "lodash";
import IconFont, { IconArrowRight } from "@/components/icon";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { changeEgovUrl, changeGovUrl, crossAppSwitch } from "@/utils/tools";
import { Avatar } from "@/baseComponents/Avatar";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import {
  isValidUserName,
  isValidMobile,
  isValidEmail,
  isValidVerCode,
  isValidTelephone
} from "@/components/LoginComp/utils";
import SearchDeptModal from "@/components/Modals/SearchDeptModal";
import AdministratorModal from "@/components/Modals/AdministratorModal";
import SanDingModal from "@/components/Modals/SanDingModal";
import Loading from "@/components/Loading";
import { getEmployeeDetailByUserIdForEbook, updateEmplInfoSubmit } from "@/api/user";
import { getEbookDeptDesc } from "@/api/ebook";
import { analysisLog } from "@/utils/logAnalytics";
import Bus from "@/utils/bus";
import { UserCardType, UserCardAction } from "@/types/UserCard";
import "./index.less";

let timer: any;

const jobTitleArr = [
  {
    key: "unitName",
    value: "单位",
    dom: "select"
  },
  {
    key: "deptName",
    value: "部门",
    dom: "select"
  },
  {
    key: "titleName",
    value: "职务",
    placeholder: "请输入您的职务"
  },
  {
    key: "duty",
    value: "职责",
    placeholder: "请输入您的职责"
  },
  {
    key: "telephone",
    value: "座机",
    editVal: "座机号码",
    placeholder: "请输入您的座机号码"
  }
];
const basicTitle: any = {
  realName: "姓名",
  mobile: "手机号",
  email: "邮箱"
};

function PersonalInfoModal({
  visible,
  onCancel,
  userInfo,
  headImg,
  username,
  selectImg,
  toPerfect,
  doShowQRCode,
  doSwitchDefaultAvatar,
  authData,
  teamUserInfo
}: {
  visible: boolean;
  onCancel: () => void;
  userInfo: any;
  headImg: string;
  username: string;
  selectImg: () => void;
  toPerfect: () => void;
  doShowQRCode: () => void;
  doSwitchDefaultAvatar: () => void;
  authData: any;
  teamUserInfo: any;
}) {
  const isPublic = userInfo.accountType === 1;
  const { service, appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const isBjwp = userInfo?.teamId === appRuntimeEnv.bjwpConfig?.teamId;
  const [employeeDetailData, setEmployeeDetailData] = useState<any>({
    basicInfoList: [],
    titleInfoList: []
  });
  const [modifyVisible, setModifyVisible] = useState(false);
  const [modifyTitle, setModifyTitle] = useState("");
  const [modifyType, setModifyType] = useState("");
  const [updateBasicInfo, setUpdateBasicInfo] = useState<any>({
    realName: "",
    mobile: "",
    email: ""
  });
  const [updateJobInfo, setUpdateJobInfo] = useState<any>({
    unitName: "",
    deptName: "",
    titleName: "",
    duty: "",
    telephone: ""
  });
  const [oldEmplInfo, setOldEmplInfo] = useState<any>({});
  const [oldJobInfo, setOldJobInfo] = useState<any>({});
  const [approvedDeptId, setApprovedDeptId] = useState("");
  const [verCode, setVerCode] = useState("");
  const [seconds, setSeconds] = useState(60);
  const [searchDeptType, setSearchDeptType] = useState("");
  const [currentUnitId, setCurrentUnitId] = useState("");
  const [searchDeptVisible, setSearchDeptVisible] = useState(false);
  const getCoding = useRef(false);
  const [visibleAdministrator, setVisibleAdministrator] = useState({ visible: false, type: "" });
  const [sanding, setSanding] = useState({ content: "", title: "", visible: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      getEmployeeDetailData();
    } catch (e) {
      message.error(e);
    }
  }, []);

  const doShowAdministrator = useCallback((type) => {
    setVisibleAdministrator({ visible: true, type });
  }, []);

  const doSwitchAdministrator = useCallback(() => {
    setVisibleAdministrator({
      ...visibleAdministrator,
      visible: !visibleAdministrator.visible
    });
  }, [visibleAdministrator]);

  const getEmployeeDetailData = async () => {
    try {
      const res = await getEmployeeDetailByUserIdForEbook({});
      const resData: any = res || {};
      const basicInfoList = [];
      const titleInfoList: any = [];
      const _basicApproveList = resData.basicInfoList;
      const _titleInfoList = resData.titleInfoList;
      const _deptApproveInfoList = resData.deptApproveInfoList;
      for (let key in basicTitle) {
        if (basicTitle.hasOwnProperty(key)) {
          const _list = _basicApproveList.filter((item: any) => {
            return item.fieldName === key;
          });
          basicInfoList.push({
            key,
            titleMsg: basicTitle[key],
            value: resData[key],
            approveStatus: _list.length ? _list[0].approveStatus : "-1",
            approveType: _list.length ? _list[0].approveType : "2"
          });
        }
      }
      let _approvedDeptId = "";
      _titleInfoList.forEach((_title: any) => {
        const _list: any = [];
        for (const item of _deptApproveInfoList) {
          if (item.deptId === _title.department) {
            _list.push(item);
            break;
          }
        }
        const _status = _list.length ? _list[0].approveStatus : "-1";
        titleInfoList.push({
          ..._title,
          approveStatus: _status,
          approveType: _list.length ? _list[0].approveType : "2"
        });
        if (_status === "1") {
          _approvedDeptId = _title.department;
        }
      });
      setApprovedDeptId(_approvedDeptId);
      setEmployeeDetailData({
        basicInfoList,
        titleInfoList,
        cardNumber: resData.cardNumber,
        userType: resData.userType
      });
      setLoading(false);
    } catch (e) {
      message.error(e);
    }
  };

  const doDeptInfo = useCallback(() => {
    setSearchDeptVisible(!searchDeptVisible);
  }, [searchDeptVisible]);

  const modifyBasicInfo = (type: string, info: any) => {
    let _title = "";
    if (type === "realName") {
      _title = "修改姓名";
    } else if (type === "email") {
      _title = "修改邮箱";
    } else if (type === "mobile") {
      _title = "修改手机号";
    }
    setModifyTitle(_title);
    setModifyType(type);
    setOldEmplInfo(info);
    setModifyVisible(true);
  };

  const onModifyCancel = () => {
    setModifyVisible(false);
    setTimeout(() => {
      setModifyTitle("");
      setModifyType("");
    }, 200);
  };

  const checkInputVal = (val: any, type: any) => {
    let errStr = "";
    if (type === "realName") {
      if (!val) {
        errStr = "请输入您的姓名";
      } else if (!isValidUserName(val)) {
        errStr = "输入的姓名格式不正确";
      }
    } else if (type === "email") {
      if (!val) {
        errStr = "请输入您的邮箱";
      } else if (!isValidEmail(val)) {
        errStr = "输入的邮箱格式不正确";
      }
    } else if (type === "mobile") {
      if (!val) {
        errStr = "请输入您的通讯录手机号";
      } else if (!isValidMobile(val)) {
        errStr = "输入的手机号格式不正确";
      }
    } else if (type === "verCode") {
      if (!val) {
        errStr = "请输入验证码";
      } else if (!isValidVerCode(val)) {
        errStr = "输入的验证码格式不正确";
      }
    }
    return errStr;
  };

  const checkJobVal = (info: any) => {
    const _errorTitle = !updateJobInfo.unitId
      ? "请输入您的单位"
      : !updateJobInfo.department
      ? "请输入您的部门"
      : !updateJobInfo.titleName
      ? "请输入您的职务"
      : "";
    return _errorTitle;
  };

  const onApprove = () => {
    let modifyTag = false;
    let updateType = "basic";
    let errorTitle = "";
    let jobObj: any = {};
    let unitId;
    let department;
    let titleName;
    let duty;
    let telephone;
    switch (modifyType) {
      case "realName":
        errorTitle = checkInputVal(updateBasicInfo.realName, modifyType);
        if (oldEmplInfo.value !== updateBasicInfo.realName) {
          modifyTag = true;
        }
        break;
      case "email":
        errorTitle = checkInputVal(updateBasicInfo.email, modifyType);
        if (oldEmplInfo.value !== updateBasicInfo.email) {
          modifyTag = true;
        }
        break;
      case "mobile":
        errorTitle = checkInputVal(updateBasicInfo.mobile, modifyType);
        if (!errorTitle) {
          errorTitle = checkInputVal(verCode, "verCode");
        }
        if (oldEmplInfo.value !== updateBasicInfo.mobile) {
          modifyTag = true;
        }
        break;
      case "job":
        errorTitle = checkJobVal(updateJobInfo);
        if (updateJobInfo.telephone && !isValidTelephone(updateJobInfo.telephone)) {
          errorTitle = "座机号码格式不正确";
        }
        unitId = oldJobInfo.unitId !== updateJobInfo.unitId;
        department = oldJobInfo.department !== updateJobInfo.department;
        titleName = oldJobInfo.titleName !== updateJobInfo.titleName;
        duty = oldJobInfo.duty !== updateJobInfo.duty;
        telephone = oldJobInfo.telephone !== updateJobInfo.telephone;
        if (unitId || department || titleName || duty || telephone) {
          modifyTag = true;
          updateType = "dept";
          jobObj = {
            unitId,
            department,
            titleName,
            duty,
            telephone
          };
        }
        break;
      default:
        break;
    }
    if (errorTitle) {
      message.error(errorTitle);
      return;
    }
    if (modifyTag) {
      updateEmplInfo(updateType, jobObj);
    } else {
      message.error("未识别到字段信息变化，请重新输入");
    }
  };

  const updateEmplInfo = (updateType: string, jobObj: any) => {
    const _param: any = {
      updateType,
      submitReason: "个人信息修改",
      newEmplInfo: {}
    };
    if (updateType === "basic") {
      _param.newEmplInfo[modifyType] = updateBasicInfo[modifyType];
    } else {
      _param.deptId = oldJobInfo.department;
      for (let key in jobObj) {
        if (jobObj.hasOwnProperty(key) && jobObj[key]) {
          _param.newEmplInfo[key] = updateJobInfo[key];
        }
      }
      if (_param.newEmplInfo["unitId"] && !_param.newEmplInfo["department"]) {
        _param.newEmplInfo["department"] = updateJobInfo["department"];
      }
    }
    if (modifyType === "mobile") {
      _param.verCode = verCode;
    }
    updateEmplInfoSubmit(_param)
      .then((res) => {
        if (res) {
          message.success(String(res));
          getEmployeeDetailData();
          onModifyCancel();
        }
      })
      .catch((err) => {
        message.error(err);
      });
  };

  const timer1 = () => {
    getCoding.current = true;
    let i = 60;
    timer = setInterval(() => {
      if (i === 0) {
        getCoding.current = false;
        clearInterval(timer);
      } else {
        i--;
        setSeconds(i);
      }
    }, 1000);
  };

  const getVerifyCode = async () => {
    if (getCoding.current) {
      return;
    }
    const updateNewMobile = updateBasicInfo.mobile;
    if (!updateNewMobile) {
      message.error("请输入您的通讯录手机号");
      return;
    }
    if (!isValidMobile(updateNewMobile)) {
      message.error("输入的手机号格式不正确");
      return;
    }
    if (oldEmplInfo.mobile === updateNewMobile) {
      message.error("输入的手机号相同");
      return;
    }
    timer1();
    const res = await service.authService.sendAdminVerfifyCodeReq({
      mobileNumber: updateNewMobile,
      businessType: "EMPLOYEE"
    });
    if (res) {
      message.success("验证码发送成功");
    }
  };

  const modifyJobInfo = (info: any) => {
    setModifyTitle("编辑职务信息");
    setOldJobInfo(info);
    setUpdateJobInfo(info);
    setModifyType("job");
    setModifyVisible(true);
  };

  const openDeptSelect = (type: string) => {
    setSearchDeptVisible(true);
    setSearchDeptType(type);
    if (type === "deptName") {
      setCurrentUnitId(updateJobInfo.unitId);
    } else {
      setCurrentUnitId("");
    }
  };

  const getCurDeptInfo = (info: any) => {
    const _curInfo: any = {};
    if (info.curType === "unitName") {
      _curInfo.unitName = info.deptName;
      _curInfo.unitId = info.deptId;
      if (_curInfo.unitId !== updateJobInfo.unitId) {
        _curInfo.deptName = "";
        _curInfo.department = "";
      }
    } else {
      _curInfo.deptName = info.deptName;
      _curInfo.department = info.deptId;
    }
    setUpdateJobInfo({
      ...updateJobInfo,
      ..._curInfo
    });
  };

  const openDescModal = useCallback((param) => {
    const { key, value, info } = param;
    if (info.isUnitDes && key === "unitName") {
      analysisLog("xtbg_pc_personal_infor_1687846378111", "4");
      getEbookDeptDesc(info.unitId, info.teamId).then((res: any) => {
        setSanding({ content: res?.deptDesc || "", title: "单位", visible: true });
      });
    } else if (info.isDeptDes && key === "deptName") {
      analysisLog("xtbg_pc_personal_infor_1687846378111", "5");
      getEbookDeptDesc(info.department, info.teamId).then((res: any) => {
        setSanding({ content: res?.deptDesc || "", title: "部门", visible: true });
      });
    } else {
      message.destroy();
      message.warning({
        content: `无${value}三定信息`,
        icon: <IconFont type="iconlog_warning" style={{ color: "#F4B754" }} />
      });
    }
  }, []);

  const changeSanding = (info: any) => {
    setSanding(info);
  };

  const onOpenUserCard = useCallback((data: { appId: string; userId: string; teamId: string }) => {
    const { userId, appId, teamId } = data;
    Bus.emit("app:toggle-user-card-modal:show", {
      visible: true,
      type: UserCardType.User,
      userId,
      teamId,
      appId,
      applyInfos: [],
      actions: [UserCardAction.Chat]
    });
  }, []);

  const menu = (
    <Menu>
      <Menu.Item>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ marginRight: "2px" }} onClick={selectImg}>
            上传头像
          </span>
          <Popover content="可上传4MB以内的JPG、JPEG、PNG、BMP、GIF格式的图片" trigger="hover">
            <IconFont style={{ marginTop: "1px" }} type="iconapp_ic_Moreinformation" />
          </Popover>
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item disabled={headImg ? false : true}>
        <span
          onClick={() => {
            if (headImg) {
              doSwitchDefaultAvatar();
            }
          }}
        >
          恢复默认头像
        </span>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Modal
        destroyOnClose
        title="个人信息"
        visible={visible}
        footer={null}
        onCancel={onCancel}
        width="360px"
        wrapClassName="personal-info-wrapper"
        bodyStyle={{
          padding: "0"
        }}
        centered={true}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "500px"
            }}
          >
            <Loading />
          </div>
        ) : (
          <div>
            <div className="info-content">
              <div className="info-card">
                <div className="card-title">基本信息</div>
                <div className="card-item avatar">
                  <span className="item-title">头像</span>
                  <div className="item-avatar">
                    <Avatar
                      styleObj={{
                        width: 36,
                        height: 36,
                        borderRadius: 4,
                        overflow: "hidden",
                        fontSize: 13,
                        cursor: "default"
                      }}
                      tag={isPublic ? "公共账号" : ""}
                      src={headImg ? changeEgovUrl(getHeadImgThumbUrl(headImg, 180, 180)) : ""}
                      name={username}
                    />
                    {/* <span className="change-user-avatar" onClick={selectImg}>
                      <IconFont
                        style={{
                          fontSize: 17,
                          color: "white",
                          backgroundColor: "#c2c2c3",
                          padding: "2px 5px",
                          borderTopLeftRadius: 5,
                          borderBottomRightRadius: 5
                        }}
                        type="iconapp_btn_camera_4"
                      />
                    </span> */}
                    {!(isPublic || isBjwp) && (
                      <Dropdown
                        overlay={menu}
                        trigger={["click"]}
                        // placement="bottomRight"
                        getPopupContainer={(trigger) => {
                          return trigger.parentNode as HTMLElement;
                        }}
                      >
                        <span
                          className="change-user-avatar"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          <IconFont
                            style={{
                              fontSize: 17,
                              color: "white",
                              backgroundColor: "#c2c2c3",
                              padding: "2px 5px",
                              borderTopLeftRadius: 5,
                              borderBottomRightRadius: 5
                            }}
                            type="iconapp_btn_camera_4"
                          />
                        </span>
                      </Dropdown>
                    )}
                  </div>
                </div>
                {employeeDetailData.basicInfoList.map((info: any) => {
                  return (
                    <div
                      key={info.key}
                      className={`card-item ${
                        info.approveType === "2" && employeeDetailData.userType === "FORMAL"
                          ? `approve ${info.approveStatus === "1" ? "" : "click-wrap"}`
                          : "external-user"
                      }`}
                      onClick={() => {
                        if (isPublic || isBjwp) {
                          return;
                        }
                        if (
                          info.approveType === "2" &&
                          employeeDetailData.userType === "FORMAL" &&
                          info.approveStatus !== "1"
                        ) {
                          modifyBasicInfo(info.key, info);
                        }
                      }}
                    >
                      {info.approveType === "2" && employeeDetailData.userType === "FORMAL" ? (
                        <>
                          <div style={{ display: "flex" }}>
                            <span className="item-title">{info.titleMsg}</span>
                            <span>{info.value || "未设置"}</span>
                          </div>
                          {info.approveStatus === "1" ? (
                            <span className="approve-btn2">审批中</span>
                          ) : (
                            <div
                              className="edit-btn"
                              // onClick={() => {
                              //   modifyBasicInfo(info.key, info);
                              // }}
                            >
                              {/* <span className="approve-btn1">需审批</span> */}
                              {!isBjwp && <span className="approve-arrow">{IconArrowRight}</span>}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <span className="item-title">{info.titleMsg}</span>
                          <span>{info.value || "未设置"}</span>
                        </>
                      )}
                    </div>
                  );
                })}
                {["mebj", "jgswy", "mebjJZB"].includes(appRuntimeEnv.runtimeConfig.key) && !isPublic && (
                  <div className="card-item approve">
                    <div>
                      <span className="item-title">北京通号</span>
                      {employeeDetailData.cardNumber ? (
                        <span>{employeeDetailData.cardNumber}</span>
                      ) : (
                        <span
                          onClick={debounce(() => {
                            if (isPublic || isBjwp) {
                              return;
                            }
                            toPerfect();
                            onCancel();
                          }, 500)}
                          style={{
                            cursor: "pointer",
                            color: isBjwp ? "" : "#1686FF"
                          }}
                        >
                          {isBjwp ? "未设置" : "去完善"}
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <div className="card-item approve">
                  <div>
                    <span className="item-title">名片</span>
                    <span
                      style={{
                        cursor: "pointer",
                        color: "#1686FF"
                      }}
                      onClick={() => {
                        analysisLog("xtbg_pc_personal_infor_1687846378111", "1");
                        if (authData) {
                          const { ddAppId, userId } = authData;
                          if (teamUserInfo) {
                            const { teamId } = teamUserInfo;
                            onOpenUserCard({ appId: ddAppId, userId, teamId });
                            setTimeout(() => {
                              onCancel();
                            }, 200);
                          }
                        }
                      }}
                    >
                      点击查看
                    </span>
                  </div>
                </div>
                <div className="card-item">
                  <span className="item-title">二维码</span>
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#1686FF"
                    }}
                    onClick={doShowQRCode}
                  >
                    点击查看
                  </span>
                </div>
              </div>
              {employeeDetailData.titleInfoList.map((info: any) => {
                return (
                  <div key={info.department} className="info-card">
                    <div
                      className={`card-title ${
                        info.approveType === "2" && employeeDetailData.userType === "FORMAL"
                          ? `approve ${
                              approvedDeptId && approvedDeptId === info.department
                                ? ""
                                : "click-wrap"
                            }`
                          : "external-user"
                      }`}
                      onClick={() => {
                        if (isPublic || isBjwp) {
                          return;
                        }
                        if (
                          info.approveType === "2" &&
                          employeeDetailData.userType === "FORMAL" &&
                          !(approvedDeptId && approvedDeptId === info.department)
                        ) {
                          if (approvedDeptId) {
                            message.warning({
                              content:
                                "存在尚未审核的其他部门信息修改，请在该审批处理完成后，再提交新的修改申请",
                              icon: <IconFont type="iconlog_warning" style={{ color: "#F4B754" }} />
                            });
                          } else {
                            modifyJobInfo(info);
                          }
                        }
                      }}
                    >
                      <span>职务信息</span>
                      {info.approveType === "2" && employeeDetailData.userType === "FORMAL" ? (
                        approvedDeptId && approvedDeptId === info.department ? (
                          <span className="approve-status2">审批中</span>
                        ) : (
                          <div
                            className="edit-btn"
                            // onClick={() => {
                            //   if (approvedDeptId) {
                            //     message.warning({
                            //       content: "存在尚未审核的其他部门信息修改，请在该审批处理完成后，再提交新的修改申请",
                            //       icon: <IconFont type="iconlog_warning" style={{ color: "#F4B754" }} />
                            //     });
                            //   } else {
                            //     modifyJobInfo(info);
                            //   }
                            // }}
                          >
                            {/* <span className="approve-btn1">需审批</span> */}
                            {!isBjwp && (
                              <>
                                <span className="text">单位或部门有变动？</span>
                                <span className="text-link">在此申请</span>
                                <span className="approve-arrow">{IconArrowRight}</span>
                              </>
                            )}
                          </div>
                        )
                      ) : null}
                    </div>
                    {jobTitleArr.map((tinfo: any) => {
                      if (!info[tinfo.key] && employeeDetailData.userType !== "FORMAL") {
                        return null;
                      }
                      return (
                        <div key={tinfo.key} className="card-item job">
                          <span className="item-title">{tinfo.value}</span>
                          <span style={{ maxWidth: "216px" }}>{info[tinfo.key]}</span>
                          {tinfo.dom === "select" ? (
                            <span
                              className="item-more"
                              onClick={() => {
                                openDescModal({
                                  key: tinfo.key,
                                  value: tinfo.value,
                                  info
                                });
                              }}
                            >
                              <IconFont type="iconapp_ic_Moreinformation" />
                            </span>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            <div className="info-footer">
              如信息有误，{isPublic || isBjwp ? "请" : "可进行修改或"}联系
              {userInfo?.userType === "1" && (
                <>
                  <span
                    className="footer-btn"
                    onClick={() => {
                      doShowAdministrator("Administrator");
                    }}
                    clstag="pageclick|keycount|xtbg_add_home_1637657110163|57"
                  >
                    管理者
                  </span>
                  或
                </>
              )}
              <span
                className="footer-btn"
                onClick={() => {
                  doShowAdministrator("unitAdministrator");
                }}
                clstag="pageclick|keycount|xtbg_add_home_1637657110163|58"
              >
                单位管理员
              </span>
            </div>
          </div>
        )}
      </Modal>
      <Modal
        title={modifyTitle}
        visible={modifyVisible}
        width={`${modifyType === "job" ? "420px" : "400px"}`}
        wrapClassName="modify-info-wrapper"
        onCancel={onModifyCancel}
        footer={
          <div>
            <Button type="default" onClick={onModifyCancel}>
              取消
            </Button>
            <Button type="primary" onClick={onApprove}>
              提交申请
            </Button>
          </div>
        }
      >
        <div style={{ marginTop: "-24px" }}>
          <div className="modify-title-wrap">
            <ul
              className={`title-ul ${
                modifyType === "mobile" || modifyType === "job" ? "more" : ""
              }`}
            >
              <li>以下信息修改，需要通过单位管理员审核后，才能生效</li>
              {modifyType === "mobile" ? (
                <li>
                  修改成功后，个人名片页的手机号展示也会同步变更；修改后不影响成员的登录手机号
                </li>
              ) : modifyType === "job" ? (
                <li>修改成功后，个人名片页的展示也会同步变更</li>
              ) : null}
            </ul>
          </div>
          {modifyType === "mobile" ? (
            <div>
              {/* <p style={{ color: "#62656D" }}>
                修改成功后，个人名片页的手机号展示也会同步变更；修改后不影响成员的登录手机号
              </p> */}
              <Input
                placeholder="请输入您的通讯录手机号"
                maxLength={11}
                value={updateBasicInfo[modifyType]}
                style={{ margin: "0 0 16px" }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^[0-9]*$/.test(val)) {
                    const _curInfo: any = {};
                    _curInfo[modifyType] = val;
                    setUpdateBasicInfo(_curInfo);
                  }
                }}
              />
              <Input
                addonAfter={
                  <span
                    className="get-code"
                    onClick={getVerifyCode}
                    style={{
                      cursor: [60, 0].includes(seconds) ? "pointer" : "",
                      color: [60, 0].includes(seconds) ? "#1686FF" : "#8F959E"
                    }}
                  >
                    {[60, 0].includes(seconds) ? "获取验证码" : `${seconds}s`}
                  </span>
                }
                placeholder="请输入验证码"
                value={verCode}
                maxLength={6}
                onChange={(e) => {
                  setVerCode(e.target.value);
                }}
              />
            </div>
          ) : modifyType === "job" ? (
            <div>
              {/* <p className="item-tip">修改成功后，个人名片页的展示也会同步变更</p> */}
              {jobTitleArr.map((tinfo: any) => {
                return (
                  <div key={tinfo.key}>
                    <p className="item-title">{tinfo.editVal || tinfo.value}</p>
                    {tinfo.dom === "select" ? (
                      <div
                        className="search-unit-wrap"
                        onClick={() => {
                          openDeptSelect(tinfo.key);
                        }}
                      >
                        <Input disabled value={updateJobInfo[tinfo.key]} placeholder="请选择" />
                      </div>
                    ) : (
                      <Input
                        value={updateJobInfo[tinfo.key]}
                        className="item-input"
                        placeholder={tinfo.placeholder}
                        maxLength={tinfo.key === "telephone" ? 20 : 200}
                        onChange={(e) => {
                          const val = e.target.value.trim();
                          const _curInfo: any = {};
                          _curInfo[tinfo.key] = val;
                          setUpdateJobInfo({
                            ...updateJobInfo,
                            ..._curInfo
                          });
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          ) : modifyType ? (
            <Input
              placeholder={modifyType === "email" ? "请输入您的邮箱" : "请输入您的姓名"}
              value={updateBasicInfo[modifyType]}
              maxLength={modifyType === "email" ? 150 : 50}
              onChange={(e) => {
                const val = e.target.value.trim();
                const _curInfo: any = {};
                _curInfo[modifyType] = val;
                setUpdateBasicInfo(_curInfo);
              }}
            />
          ) : null}
        </div>
      </Modal>
      {searchDeptVisible && (
        <SearchDeptModal
          visible={searchDeptVisible}
          title={searchDeptType === "unitName" ? "修改单位" : "修改部门"}
          placeholder={searchDeptType === "unitName" ? "请输入单位" : "请输入部门"}
          getCurDeptInfo={(info: any) => {
            getCurDeptInfo(info);
          }}
          currentUnitId={currentUnitId}
          searchDeptType={searchDeptType}
          onCancel={doDeptInfo}
        />
      )}
      {visibleAdministrator.visible && visible && (
        <AdministratorModal
          visible={visibleAdministrator.visible}
          onCancel={doSwitchAdministrator}
          type={visibleAdministrator.type}
        />
      )}
      {sanding.visible && <SanDingModal sanding={sanding} changeSanding={changeSanding} />}
    </>
  );
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfoModal);
